import { Menu } from "lucide-react"
import { usePage } from "@inertiajs/react"
import { LogoMark } from "./logo-mark"
import type { SharedProps } from "@/types/inertia"

type Props = {
  onOpenNav: () => void
}

// Mobile top bar — visible below `lg:` only. Sticky to the top of the
// viewport so the hamburger stays reachable as the page scrolls. Three
// slots: hamburger (opens NavDrawer), centered logo + wordmark, and the
// current operator's avatar (mirrors the company switcher row at the
// bottom of the desktop sidebar).
//
// The avatar is a non-interactive identity affordance for now — clicks
// open nothing on mobile. The desktop sidebar's company switcher +
// sign-out cluster lives inside the NavDrawer where there's room.
export function MobileTopBar({ onOpenNav }: Props) {
  const page = usePage<SharedProps>()
  const user = page.props.current_user
  const initial = (user?.name ?? user?.email ?? "?").trim().charAt(0).toUpperCase()

  return (
    <header className="sticky top-0 z-40 flex h-16 items-center justify-between border-b border-border bg-app-panel/92 px-4 backdrop-blur lg:hidden">
      <button
        type="button"
        onClick={onOpenNav}
        aria-label="Open navigation"
        className="grid h-11 w-11 place-items-center rounded-2xl border border-border bg-white/[0.03] text-app-text transition hover:bg-white/10"
      >
        <Menu size={20} strokeWidth={2.25} />
      </button>

      <div className="flex items-center gap-2">
        <LogoMark small />
        <div className="text-base font-semibold leading-none">
          Valet<span className="text-brand-red">.red</span>
        </div>
      </div>

      <div
        aria-label={user?.email ?? "Account"}
        className="grid h-11 w-11 place-items-center rounded-full border border-border bg-brand-red/80 text-base font-bold text-white"
      >
        {initial}
      </div>
    </header>
  )
}
